// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"a7ef9458","622":"e28ed600","661":"6633acd3","712":"63827959","725":"553f8459","815":"e956a185","839":"8744408e","878":"e88690b4","944":"52890e90"}[chunkId] + ".chunk.js";
};